import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";

const IcoContato = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-envelope-at-fill" viewBox="0 0 16 16">
    <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
    <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
  </svg>
);

const IcoSobre = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-info-square-fill" viewBox="0 0 16 16">
    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </svg>
);

const IcoGuias = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-journal-code" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M8.646 5.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 8 8.646 6.354a.5.5 0 0 1 0-.708m-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 8l1.647-1.646a.5.5 0 0 0 0-.708" />
    <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
    <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
  </svg>
);

const guiasLinks = [
  { slug: "assembly-arm64", titulo: "Assembly ARM64", cor: "#1ead8a" },
  { slug: "subagents-claude", titulo: "Subagents — Claude Code", cor: "#d97706" },
  { slug: "motores-robotica", titulo: "Motores para Robôs", cor: "#e06050" },
];

function Home() {
  const navigate = useNavigate();

  return (
    <Container className="mb-5">
      <h1>HOME</h1>
      <hr />
      <h3>Bem vindo ao meu laboratório!</h3>
      <h6>DISCLAIMER: Eu não gosto de front-end. Mas depois que um professor me mostrou como hospedar um site, não resisti à tentação.</h6>
      <p>
        Feita esta primeira observação, este é o lugar que eu escolhi para fazer experiências, ter sucesso e fracasso.<br />
        O primeiro fracasso deste site foi tentar integrar React e Bootstrap.<br />
        O primeiro sucesso foi achar o framework React-Bootstrap, que faz exatamente o que eu estava buscando.<br />
        O segundo sucesso foi assinar o Claude. Como eu já disse que não gosto de front-end, isso foi um "game changer" que me fez colocar
        a mão nesta página após os dois anos de sua criação.
      </p>
      <hr />
      <h3>Mapa do site</h3>
      <p>Por onde começar:</p>
      <Row xs={1} md={3} className="g-3 mt-2">
        <Col>
          <Card className="h-100 guias-card" onClick={() => navigate("/Contato")}>
            <Card.Body>
              <Card.Title className="d-flex align-items-center gap-2">
                <IcoContato /> CONTATO
              </Card.Title>
              <Card.Text className="small">
                E-mail com verificação em duas etapas, LinkedIn e Discord — os canais para falar comigo.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="h-100 guias-card" onClick={() => navigate("/Sobre")}>
            <Card.Body>
              <Card.Title className="d-flex align-items-center gap-2">
                <IcoSobre /> SOBRE
              </Card.Title>
              <Card.Text className="small">
                Quem eu sou: formação, experiência profissional e a minha visão sobre IA.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="h-100 guias-card" onClick={() => navigate("/Guias")}>
            <Card.Body>
              <Card.Title className="d-flex align-items-center gap-2">
                <IcoGuias /> GUIAS
              </Card.Title>
              <Card.Text className="small">Guias de estudo interativos:</Card.Text>
              <ul className="list-unstyled small mb-0">
                {guiasLinks.map((g) => (
                  <li key={g.slug}>
                    <span style={{ color: g.cor }}>▸</span>{" "}
                    <a
                      href={`/Guias/${g.slug}`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate(`/Guias/${g.slug}`);
                      }}
                    >
                      {g.titulo}
                    </a>
                  </li>
                ))}
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
